(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.Router = (function() {
    function Router() {
      this.registerRoutes = bind(this.registerRoutes, this);
      this.register = bind(this.register, this);
      this._makeQualifiedName = bind(this._makeQualifiedName, this);
      this.filter = bind(this.filter, this);
      this.factory = bind(this.factory, this);
      this.service = bind(this.service, this);
      this.controller = bind(this.controller, this);
    }

    Router.prototype.controller = function(path, inject, customname) {
      var cls, name;
      if (inject == null) {
        inject = [];
      }
      if (customname == null) {
        customname = null;
      }
      name = this._makeQualifiedName(path, customname, 'Controllers');
      cls = App.loadClass(path);
      inject.push(cls);
      return this.module.controller(name, inject);
    };

    Router.prototype.service = function(path, inject, customname) {
      var cls, name;
      if (inject == null) {
        inject = [];
      }
      if (customname == null) {
        customname = null;
      }
      name = this._makeQualifiedName(path, customname, 'Services');
      cls = App.loadClass(path);
      inject.push((function(_this) {
        return function() {
          return (function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
          })(cls, arguments, function(){});
        };
      })(this));
      return this.module.factory(name, inject);
    };

    Router.prototype.factory = function() {
      var ref;
      return (ref = this.module).factory.apply(ref, arguments);
    };

    Router.prototype.filter = function() {
      var ref;
      return (ref = this.module).filter.apply(ref, arguments);
    };

    Router.prototype._makeQualifiedName = function(path, customname, mid_prefix) {
      var name;
      name = path.split('/');
      name = customname != null ? customname : mid_prefix + '.' + List.last(name);
      if (this.prefix == null) {
        console.log("WARNING: No prefix used when registering " + name + ". This could lead to name clashes");
      } else {
        name = this.prefix + '.' + name;
      }
      return name;
    };

    Router.prototype.register = function() {
      return void 0;
    };

    Router.prototype.registerRoutes = function() {
      return void 0;
    };

    return Router;

  })();

}).call(this);
